import { themr } from '@friendsofreactjs/react-css-themr';

import InvoiceItem from './InvoiceItem';

export default themr('InvoiceItem')(InvoiceItem);
